/**
 * Calculate reading time for text content
 * Average reading speed is ~200-250 words per minute
 */
export const calculateReadingTime = (content) => {
  if (!content) return 1;
  
  // Strip HTML tags
  const textOnly = content.replace(/<[^>]*>/g, ' ');
  
  // Count words
  const words = textOnly.trim().split(/\s+/).filter(word => word.length > 0);
  const wordCount = words.length;
  
  // Calculate time (assuming 200 words per minute for technical content)
  const readingTime = Math.ceil(wordCount / 200);
  
  // Return at least 1 minute
  return Math.max(1, readingTime);
};

/**
 * Format reading time for display
 */
export const formatReadingTime = (minutes) => {
  if (minutes === 1) return '1 min read';
  return `${minutes} min read`;
};
